(function(){
  "use strict";

  var dataEl = document.getElementById("jumiProductData");
  var DATA = dataEl ? JSON.parse(dataEl.textContent) : {};

  var COLORS = ["RED","GREEN","BLUE"];
  var ACCENTS = { RED: "#ff3d3d", GREEN: "#4dffa3", BLUE: "#57b6ff" };

  var state = { color: "RED", size: null };

  var els = {
    machineImgs: document.querySelectorAll(".machine-img"),
    heroShoes: document.querySelectorAll(".hero-shoe"),
    shoeWashes: document.querySelectorAll(".shoe-wash"),
    glows: document.querySelectorAll(".glow"),
    colorLabel: document.getElementById("colorLabel"),
    swatches: document.querySelectorAll(".swatch"),
    productTitle: document.getElementById("productTitle"),
    price: document.getElementById("price"),
    sizes: document.querySelectorAll(".size"),
    addToCart: document.getElementById("addToCart"),
    cartForm: document.getElementById("jumiAddForm"),
    variantInput: document.getElementById("variantIdInput"),
    sizeInput: document.getElementById("sizePropertyInput"),
    hint: document.getElementById("hint"),
    bagCount: document.getElementById("bagCount"),
    arrowLeft: document.getElementById("arrowLeft"),
    arrowRight: document.getElementById("arrowRight"),
    signGlow: document.getElementById("signGlow"),
    knobGlow: document.getElementById("knobGlow"),
    buttonGlow: document.getElementById("buttonGlow")
  };

  function setColor(color){
    if (color === state.color) return;
    state.color = color;
    state.size = null;
    render();
  }

  function cycle(delta){
    var i = COLORS.indexOf(state.color);
    setColor(COLORS[(i + delta + COLORS.length) % COLORS.length]);
  }

  function render(){
    var color = state.color;
    var accent = ACCENTS[color];
    var info = DATA[color] || {};

    els.machineImgs.forEach(function(img){
      img.classList.toggle("is-active", img.dataset.color === color);
    });
    els.heroShoes.forEach(function(img){
      img.classList.toggle("is-active", img.dataset.color === color);
    });
    els.shoeWashes.forEach(function(w){
      w.classList.toggle("is-active", w.dataset.color === color);
    });
    els.glows.forEach(function(g){
      g.classList.toggle("is-active", g.dataset.color === color);
    });

    els.colorLabel.textContent = color;
    els.colorLabel.style.color = accent;

    els.productTitle.textContent = info.title || (color + " SPOTTED VANS");
    els.productTitle.style.color = accent;

    els.price.textContent = info.price || "";

    els.swatches.forEach(function(sw){
      var active = sw.dataset.color === color;
      sw.setAttribute("aria-pressed", active ? "true" : "false");
      sw.style.borderColor = active ? accent : "";
      sw.style.color = active ? "#f2f2f0" : "";
    });

    els.sizes.forEach(function(btn){
      var selected = state.size === btn.dataset.size;
      btn.classList.toggle("is-selected", selected);
      btn.style.borderColor = selected ? accent : "";
    });

    var dotGlow = "radial-gradient(circle, #ffffff 0%, " + accent + " 40%, transparent 72%)";
    var barGlow = "radial-gradient(ellipse, #ffffff 0%, " + accent + " 45%, transparent 75%)";
    els.signGlow.style.background = barGlow;
    els.knobGlow.style.background = dotGlow;
    els.buttonGlow.style.background = dotGlow;

    els.variantInput.value = info.variantId || "";

    if (!info.variantId || !info.available){
      els.addToCart.textContent = "SOLD OUT";
      els.addToCart.disabled = true;
      els.addToCart.style.borderColor = "";
    } else {
      els.addToCart.textContent = "ADD TO CART";
      els.addToCart.disabled = false;
      els.addToCart.style.borderColor = accent;
    }

    els.hint.textContent = "";
  }

  function sizeLabel(size){
    return size.indexOf(".5") > -1 ? size.replace(".5", "½") : size;
  }

  function refreshCartCount(){
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (els.bagCount) els.bagCount.textContent = cart.item_count;
      })
      .catch(function(){});
  }

  els.cartForm.addEventListener("submit", function(e){
    e.preventDefault();
    var info = DATA[state.color] || {};

    if (!info.variantId || !info.available) return;

    if (!state.size){
      els.hint.textContent = "SELECT A SIZE FIRST";
      return;
    }

    els.sizeInput.value = state.size;

    var btn = els.addToCart;
    var formData = new FormData(els.cartForm);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { "Accept": "application/json" }
    })
      .then(function(r){
        if (!r.ok) return r.json().then(function(err){ throw err; });
        return r.json();
      })
      .then(function(){
        btn.classList.add("is-added");
        btn.textContent = "ADDED — SIZE " + sizeLabel(state.size);
        refreshCartCount();
        setTimeout(function(){
          btn.classList.remove("is-added");
          render();
        }, 1100);
      })
      .catch(function(){
        els.hint.textContent = "COULDN'T ADD TO CART — TRY AGAIN";
      });
  });

  els.arrowRight.addEventListener("click", function(){ cycle(1); });
  els.arrowLeft.addEventListener("click", function(){ cycle(-1); });

  els.swatches.forEach(function(sw){
    sw.addEventListener("click", function(){ setColor(sw.dataset.color); });
  });

  els.sizes.forEach(function(btn){
    btn.addEventListener("click", function(){
      state.size = btn.dataset.size;
      render();
    });
  });

  document.addEventListener("keydown", function(e){
    if (e.key === "ArrowRight") cycle(1);
    if (e.key === "ArrowLeft") cycle(-1);
  });

  render();
})();
